<template>
	<div class="content">
		<div class="section">
			<div class="tag flex-row">
				<img src="../../assets/img/icon-left.png">
				<span>订单信息</span>
				<img src="../../assets/img/icon-right.png">
			</div>
			<div class="info">
				<div class="data">
					订单编号：SK23031601105888
				</div>
				<div class="data">
					入馆日期：2023-03-17 09:00-10:00
				</div>
				<div class="data flex-row">
					订单状态：<span style="color: #E34D59; font-weight: 600;">待支付</span>
					<div class="tip">
						重要提醒：请及时支付订单金额，超时将自动取消，详细问题请联系客服
					</div>
					<div class="cancelbtn cursorp">
						取消预约
					</div>
				</div>
				<div class="data">
					订单金额： <span class="price" style="color: #37695C;">￥60</span>
				</div>
			</div>
			<div class="table">
				<div class="tableHeader flex-row">
					<div class="item">
						姓名
					</div>
					<div class="item">
						证件类型
					</div>
					<div class="item idCard">
						证件号码
					</div>
					<div class="item">
						门票名称
					</div>
					<div class="item">
						票价
					</div>
				</div>
				<div class="tBody">
					<div class="th flex-row" v-for="(item,index) in list" :key="index">
						<div class="data">
							王五
						</div>
						<div class="data">
							身份证
						</div>
						<div class="data">
							244************488
						</div>
						<div class="data flex-row">
							普通票
						</div>
						<div class="data">
							￥25
						</div>
					</div>
				</div>
			</div>
			<div class="tag flex-row">
				<img src="../../assets/img/icon-left.png">
				<span>支付方式</span>
				<img src="../../assets/img/icon-right.png">
			</div>
			<div class="paymode flex-row">
				<div class="item">
					<el-radio v-model="radio" label="1"> <img src='../../assets/img/icon-juhe.png'> 聚合支付</el-radio>
				</div>
				<div class="item">
					<el-radio v-model="radio" label="2"> <img src='../../assets/img/icon-wechat.png'> 微信支付</el-radio>
				</div>
				<div class="item">
					<el-radio v-model="radio" label="3"> <img src='../../assets/img/icon-Alipay.png'> 支付宝支付</el-radio>
				</div>
				<div class="item">
					<el-radio v-model="radio" label="4"> <img src='../../assets/img/icon-rmb.png'> 数字人民币</el-radio>
				</div>
			</div>
			<div class="tag flex-row">
				<img src="../../assets/img/icon-left.png">
				<span>温馨提示</span>
				<img src="../../assets/img/icon-right.png">
			</div>
			<div class="detail">
				<div class="item flex-row">
					<img src="../../assets/img/icon-tip1.svg">
					请携带身份证，于约定日期刷证或者凭借二维码核销入馆
				</div>
				<div class="item flex-row">
					<img src="../../assets/img/icon-tip1.svg">
					门票如未使用，请在参观日23:00前退票，超过时限则无法退票
				</div>
				<div class="item flex-row">
					<img src="../../assets/img/icon-tip1.svg">
					支付完成后如需在PC端查询门票，可到【订单查询】进行查询搜索
				</div>
			</div>
			<img class="line" src='../../assets/img/icon-line.svg'>
			<div class="btnbox flex-row">
				<div class="backbtn cursorp">
					返回
				</div>
				<router-link to="/">
					<div class="prevbtn cursorp">
						立即支付
					</div>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'UnPay',
		data() {
			return {
				list: [1, 2, 3, 4],
				radio: ''
			}
		},
	}
</script>

<style scoped>
	.content {
		width: 1200px;
		margin: auto;
		background: #FFFFFF;
		box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
		border-radius: 6px;
		padding: 24px;
		box-sizing: border-box;
	}

	.section {
		width: 100%;
	}

	.section .info {
		width: 1007px;
		margin-left: 60px;
		margin-bottom: 8px;
		position: relative;
	}

	.section .info .data {
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #000000;
		margin-bottom: 20px;
		position: relative;
	}

	.info .tip {
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #BB2916;
		height: 24px;
		background: #E1FEF7;
		border-radius: 12px;
		border: 1px solid #BB2916;
		line-height: 24px;
		margin-left: 10px;
		padding: 0 6px;
		box-sizing: border-box;
	}

	.info .cancelbtn {
		width: 92px;
		height: 38px;
		background: #FFFFFF;
		border-radius: 30px;
		border: 1px solid #BB2916;
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #BB2916;
		line-height: 38px;
		text-align: center;
		position: absolute;
		top: 0;
		right: 0;
	}

	.info .price {
		font-size: 20px;
		font-weight: 600;
	}

	.section .table {
		width: 1007px;
		padding: 0 60px;
		box-sizing: border-box;
		margin-bottom: 24px;
	}

	.table .tableHeader {
		width: 1007px;
		height: 64px;
		border-radius: 6px 6px 0px 0px;
		background-image: url('../../assets/img/tableBG.svg');
		background-size: 100% 100%;
		background-repeat: no-repeat;
		justify-content: space-between;
	}

	.table .tableHeader .item {
		font-size: 16px;
		font-family: PingFang SC-Semibold, PingFang SC;
		font-weight: 600;
		color: #FFFFFF;
		width: 201px;
		text-align: center;
	}

	.table .tBody {
		width: 1007px;
		border: 1px solid #F1F1F1;
	}

	.table .tBody .th {
		width: 100%;
		height: 63px;
		justify-content: space-between;
		border-bottom: 1px solid #F1F1F1;
	}

	.table .tBody .th:last-child {
		border: none !important;
	}

	.tBody .data span {
		display: block;
		width: 60px;
		height: 23px;
		background: #BB2916;
		border-radius: 6px;
		font-size: 12px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		margin-left: 7px;
		line-height: 23px;
	}

	.tBody .th .data {
		font-size: 16px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		width: 201px;
		text-align: center;
		padding: 0 6px;
		box-sizing: border-box;
		justify-content: center;
	}

	.returnTicket {
		color: #999999 !important;
	}

	.section .paymode {
		padding: 0 60px;
		box-sizing: border-box;
		width: 100%;
		margin-bottom: 24px;
	}

	.section .paymode .item {
		margin-right: 16px;
	}

	.section .paymode .item img {
		width: 48px;
		height: 48px;
		margin-right: 14px;
	}

	.section .detail {
		margin: 24px 0;
		margin-left: 60px;
	}

	.detail .item {
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #000000;
		margin-bottom: 20px;
	}

	.detail .item img {
		width: 14px;
		height: 14px;
		margin-right: 4px;
	}

	.line {
		width: 1038px;
		height: 6px;
		margin: 24px 0;
		margin-left: 60px;
	}

	.btnbox {
		justify-content: center;
	}

	.btnbox div {
		width: 324px;
		height: 60px;
		font-size: 22px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		text-align: center;
		line-height: 60px;
		border-radius: 30px;
	}

	.btnbox .backbtn {
		color: #3A6E61;
		background: #FFFFFF;
		border: 1px solid #3A6E61;
		margin-right: 32px;
	}

	.btnbox .prevbtn {
		color: #FFFFFF;
		background: #BB2916;
	}

	/deep/ .el-radio {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	/deep/.el-radio .el-radio__label {
		display: flex;
		flex-direction: row;
		align-items: center;
		color: #000000;
	}

	/deep/ .el-radio__inner {
		width: 20px;
		height: 20px;
		background: #F3F3F3;
		border: 2px solid #BB2916
	}

	/deep/ .el-radio__input.is-checked .el-radio__inner {
		border-color: #BB2916;
		background: #BB2916;

	}

	/deep/.el-radio__input.is-checked+.el-radio__label {
		color: #000000;
	}
</style>